import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useAuth, formatApiErrorDetail } from '../../auth';

export const useConnectionStatus = (provider) => {
  const { user } = useAuth();
  const [data, setData] = useState(null), [error, setError] = useState('');
  const pending = useRef(null), owner = useRef(user.id); owner.current = user.id;
  const reload = useCallback(async (options = {}) => {
    if (pending.current && !options.force) return;
    pending.current?.abort();
    const controller = new AbortController(), requestedOwner = owner.current;
    pending.current = controller;
    try {
      const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/account/${provider}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('gv_token')}` }, signal: controller.signal, timeout: 10000,
      });
      if (!controller.signal.aborted && requestedOwner === owner.current) { setData(result.data); setError(''); }
    } catch (failure) {
      if (!controller.signal.aborted && requestedOwner === owner.current) setError(formatApiErrorDetail(failure.response?.data?.detail || `Could not load the ${provider} connection.`));
    } finally { if (pending.current === controller) pending.current = null; }
  }, [provider]);
  useEffect(() => {
    setData(null); setError(''); reload();
    const refresh = () => { if (document.visibilityState === 'visible') reload(); };
    window.addEventListener('focus', refresh);
    const timer = setInterval(refresh, 10000);
    return () => { pending.current?.abort(); pending.current = null; clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [reload, user.id, user.has_password]);
  const applyData = useCallback((value) => { pending.current?.abort(); pending.current = null; setData(value); setError(''); }, []);
  return { data, error, reload, setData: applyData };
};